// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1WKoj","itemTitle":"ClientEmergencyInfo_itemTitle__1r-aQ","itemText":"ClientEmergencyInfo_itemText__2sQNE"};